import React from 'react';

export default function Table({ children, className = '', style }) {
  const cls = ['table'];
  if (className) cls.push(className);
  return (
    <table className={cls.join(' ')} style={style}>
      {children}
    </table>
  );
}
